// extracted by mini-css-extract-plugin
export default {"Title":"Um72ah85x9v0wkXOUoe7","ReadOnlyNotice":"eG26CJA2WFH8UGEYOJhD","Fieldset":"ys2BYJFEpo7P29ryOcJL"};